import { PricePerUnit } from './price-per-unit'

export const defaultTotalStockUnits = 100000

export type StockConfiguration = {
  minPerTransaction: number
  total: number
  pricePerUnit: PricePerUnit
}
